var lastFocusableHeaderElement;

(function ($) {
    var NAV_ITEM_ACTIVE = 'nav-main-item-active';
    var NAV_MEGANAV = 'nav-meganav';
    var NAV_MEGANAV_OPEN = 'nav-meganav-open';
    var NAV_MEGANAV_ACTIVE = 'nav-meganav-active';
    var NAV_SEARCH_OPEN = 'nav-search-open';
    var NAV_ITEM_SEARCH_TRIGGER = 'nav-main-search-trigger';

    bindEvents();
    $('.nav-meganav-close').on('keypress', function (e) {
        if (e.which == 13) {
            $(this).click();
        }
    });

    $(".nav-main-search-trigger").click(function () {
        // to close the menu when search is clicked
        $('.nav-main-icons .navbar-collapse').removeClass('show');
        $('.nav-item.dropdown').removeClass('show');
        $('.nav-item.dropdown').each(function () {
            $(this).children('.dropdown-menu').first().removeClass('show');
        });
        $("#txtSearch").val('');
        if ($('.nav-main-search-trigger').attr('aria-expanded') === 'false') {
            $(".nav-main-search-trigger").attr('aria-expanded', true);
        } else {
            $(".nav-main-search-trigger").attr('aria-expanded', false);
        }

        if ($('#lefttxtSearch').parent().attr('aria-expanded') === 'false') {
            $('#lefttxtSearch').parent().attr('aria-expanded', true);
        } else {
            $('#lefttxtSearch').parent().attr('aria-expanded', false);
        }

        setFocusElementHeader();
    });

    function bindEvents() {
        $('body')
            .on('click', '.nav-main-item', onMainItemClick)
            .on('click', '.nav-meganav-close', closeAll)
            .on('click', onClickAnywhere);
    }

    $(document).ready(function () {
        $('#navbarNavDropdown .navbar-nav li.nav-item.dropdown .dropdown-menu *').on('focus', function (event) {
            $("html").addClass("navbar-main");
        });
        $('#navbarNavDropdown .navbar-nav li.nav-item.dropdown .dropdown-menu *').on('focusout', function (event) {
            $("html").removeClass("navbar-main");
        });
        $('#navbarNavDropdown a.nav-link:not(.dropdown-toggle)').on('focus', function () {
            $("html").removeClass("navbar-main");
        });
        $('.component.logo *').on('focus', function (event) {
            $("html").removeClass("navbar-main");
        });
        $('#navbarNavDropdown').on('hide.bs.dropdown', function (e) {
            if (e.clickEvent) {
                $("html").removeClass("navbar-main");
            }
        });
        $('#navbarNavDropdown a.nav-link.dropdown-toggle').on('click', function () {
            $("html").addClass("navbar-main");
        });
        $("#navbarNavDropdown .nav-item.dropdown > a.nav-link.dropdown-toggle").on('click', function () {
            if ($(this).parent().hasClass("show"))
                $("html").removeClass("navbar-main");
        });

        $("#navbarNavDropdown .nav-item.dropdown > a.nav-link.dropdown-toggle").on('focus', function () {
            if ($(this).parent().hasClass("show")) {
                $("html").addClass("navbar-main");
            }
            else {
                $("html").removeClass("navbar-main");
            }
        });

        //FLWEP2-7529 - Expandable menu changes - start
        if ($(document).width() > 991) {
            if ($("li.nav-expandable-menu").length) {
                $("li.nav-expandable-menu").each(function () {
                    var divelement = $(this).children(".dropdown-menu").first();
                    hideShowExpandableMenu($(divelement));
                });
            }
            else {
                $("li.nav-expandable-menu").next(".nav-meganav-subitem").each(function () {
                    hideShowExpandableMenu($(this));
                });
                $("li.nav-expandable-menu").next("div").each(function () {
                    hideShowExpandableMenu($(this));
                });
            }
            if ($("li.nav-meganav-title.nav-expandable-menu").parents().hasClass("left-nav")) {
                $("li.nav-meganav-title.nav-expandable-menu").on("keypress", onClickAnywhere);
            }
            else {
                $("li.nav-meganav-title.nav-expandable-menu").attr("tabindex", "0");
                $("li.nav-meganav-title.nav-expandable-menu").on("keypress", onClickAnywhere);
            }
        }

        //FLWEP2-7529 - Expandable menu changes - end
    });

    //  var lastFocusableHeaderElement;

    function setFocusElementHeader() {
        setTimeout(function () {
            if ($('html.nav-search-open').length) {
                if ($("html").hasClass("nav-search-open")) {
                    $(".body-content").attr("aria-hidden", "true");
                    $("#footer").attr("aria-hidden", "true");
                    $("body > .body-wrapper > .component").attr("aria-hidden", "true");
                }

                var focusableElements = 'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
                var headerSelection = document.querySelector('header'); // select the header session
                var firstFocusableElement = headerSelection.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
                var focusableContent = headerSelection.querySelectorAll(focusableElements);
                lastFocusableHeaderElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

                $(lastFocusableHeaderElement).off("keydown").on('keydown', function (e) {
                    // add all the elements inside modal which you want to make focusable
                    var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
                    if (!isTabPressed) {
                        return;
                    }

                    if (e.shiftKey) { // if shift key pressed for shift + tab combination
                        if (document.activeElement === firstFocusableElement) {
                            lastFocusableHeaderElement.focus(); // add focus for the last focusable element
                            e.preventDefault();
                        }
                    } else { // if tab key is pressed
                        if (document.activeElement === lastFocusableHeaderElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                            firstFocusableElement.focus(); // add focus for the first focusable element
                            e.preventDefault();
                        }
                    }
                });
            } else {
                if (lastFocusableHeaderElement)
                    $(lastFocusableHeaderElement).off("keydown");

                if (!$("html").hasClass("nav-search-open")) {
                    $(".body-content").removeAttr("aria-hidden");
                    $("#footer").removeAttr("aria-hidden");
                    $("body > .body-wrapper > .component").removeAttr("aria-hidden");
                }
            }
        }, 100);
    }

    function onMainItemClick(e) {
        var item = $(this);
        var link = item.is('a') ? item : item.children('a');
        if (link.attr('href') != '#') return;

        var isActive = item.hasClass(NAV_ITEM_ACTIVE);
        var isSearch = item.hasClass(NAV_ITEM_SEARCH_TRIGGER);
        var isNavIcon = item.hasClass('nav-icon-trigger');
        e.preventDefault();

        if ((isActive && isSearch) || (isActive && isNavIcon)) {
            closeAll();
            return false;
        }

        if (isSearch) {
            openSearch(item);
        } else {
            deactivate(NAV_SEARCH_OPEN);
            openMegaNav(item);
        }
    }

    //FLWEP2-7529 - Expandable menu changes
    function hideShowExpandableMenu(expandableMenu) {
        if ($(expandableMenu).hasClass("nav-expandable-menu-open"))
            $(expandableMenu).show();
        else
            $(expandableMenu).hide();
    }

    //FLWEP2-7529 - Expandable menu changes
    function expandMenu(expandableMenu, classtoFind) {
        var divClass = ".dropdown-menu";
        var divelement = $(expandableMenu).children(".dropdown-menu").first();
        var divdropdown = $(expandableMenu).children().find('.nav-meganav-subitem').first();
        var dropdown_submenu = false;
        if (expandableMenu.hasClass("nav-meganav-title")) {
            divClass = ".nav-meganav-subitem";
            divelement = $(expandableMenu).next(divClass);
            if (divelement.length == 0) {
                divelement = $(expandableMenu).next("div");
            }
            if (((divelement.length == 0) || (((divelement.parent().html())) == ($(expandableMenu).parent().html()))) && (divdropdown.length > 0)) {
                dropdown_submenu = true;
                nextLevelDropdown = $(expandableMenu).children().find('.nav-meganav-title').first();
                lastLevelDropdown = $(expandableMenu).children().find('.nav-meganav-subitem').first();
                divelement = (nextLevelDropdown.length == 0) ? lastLevelDropdown : nextLevelDropdown;
            }
        }
        $(divelement).each(function () {
            if ($(this).hasClass("nav-expandable-menu-open")) {
                $(this).removeClass("nav-expandable-menu-open");
                $(this).hide();
            }
            else if (dropdown_submenu == true) {
                if ($(this).closest(".dropdown-menu").hasClass('nav-expandable-menu-open') == true) {
                    $(this).closest(".dropdown-menu").toggleClass("nav-expandable-menu-open");
                    $(expandableMenu).children(".dropdown-menu").css("display", "none");
                }
                else {
                    $(this).closest(".dropdown-menu").toggleClass("nav-expandable-menu-open");
                    $(expandableMenu).children(".dropdown-menu").css("display", "block");
                }
            }
            else {
                $(this).addClass("nav-expandable-menu-open");
                $(this).show();
            }
            if ($(this).parents().hasClass('left-nav')) {
                var childMargin = parseInt($(this).closest("ul").css("margin-left"));
                var childPadding = parseInt($(this).parents('.nav-expandable-menu-open').first().css('padding-left'));
                var childBorder = parseInt($(this).parents('.nav-expandable-menu-open').first().css('border-left'));
                var childLevel = $(this).parents('.nav-expandable-menu-open').length;
                childLevel = childLevel > 0 ? (childLevel * (childMargin + childPadding + childBorder)) : (childMargin + childPadding + childBorder);
                var parentWidth = $(this).parents().eq(5).width();
                var ulWidth = parentWidth - childLevel;
                $(this).closest("ul").css("width", ulWidth);
            }
            $(expandableMenu).find('.fa').first().toggleClass('fa-chevron-up fa-chevron-down');
        });

        return;
    }

    function onClickAnywhere(e) {
        var $this = $(e.target);
        //FLWEP2-7529 - Expandable menu changes
        var expandableMenu = "";
        if ($this.hasClass("nav-expandable-menu")) {
            if ($(document).width() > 991) {
                expandableMenu = $this.hasClass(".nav-expandable-menu");
                expandMenu(expandableMenu);
                e.stopPropagation();
            }
        }
        else if ($this.closest(".nav-expandable-menu").length) {
            var navLink = $this.closest("a");
            var hrefVal = $(navLink).attr("href").includes("void(0)");
            if ($(document).width() > 991) {
                expandableMenu = $this.closest(".nav-expandable-menu");
                if (hrefVal) {
                    expandMenu(expandableMenu);
                }
                e.stopPropagation();
            }
        }
        else {
            if (!isPartOfMegaNav($this) && !$this.parents(".menu-nav-indicator-container").length) {
                closeAll();
                $(".menu-nav-indicator").empty().remove();
            }
            else if ($this.parents(".menu-nav-indicator-container").length) {
                $(".menu-nav-indicator").empty().remove();
            }
        }
    }

    function isPartOfMegaNav(element) {
        var megaNav = thisOrClosest(element, 'nav-meganav');
        var navItem = thisOrClosest(element, 'nav-main-item');
        var search = thisOrClosest(element, 'nav-main-search');
        var navLink = thisOrClosest(element, 'nav-link');
        return (search.length || megaNav.length || navItem.length || navLink.length);
    }

    function KoreaBreadcrumbSpace() {
        if ($(".headerkorea").hasClass("fixed-nav-header")) {
            $(".headerkorea .breadcrumb-panel").removeClass("breadcrumbPos-IOS");
            $(".headerkorea").find(".nav-main-search.search-box").css("height", "87px");
        } else {
            if ($(".headerkorea").find(".nav-main-search-trigger").hasClass("nav-main-item-active")) {
                $(".headerkorea .breadcrumb-panel").removeClass("breadcrumbPos-IOS");
                $(".headerkorea").find(".nav-main-search.search-box").css("height", "87px");
            } else {
                $(".headerkorea .breadcrumb-panel").addClass("breadcrumbPos-IOS");
                $(".headerkorea").find(".nav-main-search.search-box").css("height", "auto");
            }
        }
    }

    function openSearch(item) {
        item.addClass(NAV_ITEM_ACTIVE);
        deactivate(NAV_MEGANAV_ACTIVE);
        $('html').addClass(NAV_SEARCH_OPEN);
        $('.nav-main-search input').focus();
        $('.nav-main-search input#txtSearch').focus();
        $('.nav-main-search input#lefttxtSearch').focus();
        $('.mega-menu-nav > .nav-main-item.nav-main-item-active').removeClass(NAV_ITEM_ACTIVE);
        if ($(window).width() < 992) {
            if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
                KoreaBreadcrumbSpace();
            }
        }
    }

    function openMegaNav(item) {
        var megaNav = $('#' + item.attr('rel'));
        deactivate(NAV_ITEM_ACTIVE);
        item.addClass(NAV_ITEM_ACTIVE);
        deactivate(NAV_MEGANAV_ACTIVE);
        megaNav.addClass(NAV_MEGANAV_ACTIVE);
        $('html').addClass(NAV_MEGANAV_OPEN);
    }

    function closeAll() {
        $(".nav-item.dropdown.show > a").focus();
        $(".mega-menu-nav .nav-main-item-active a").focus();
        deactivate(NAV_ITEM_ACTIVE);
        deactivate(NAV_MEGANAV_ACTIVE);
        deactivate(NAV_MEGANAV_OPEN);
        deactivate(NAV_SEARCH_OPEN);
        $('.nav-main-item').attr('aria-expanded', false);
        $('.nav-main-item a').each(function () {
            var href = $(this).attr('href');
            if (href && href.includes('#')) {
                $(this).attr('aria-expanded', false);
            }
        });
        $("html").removeClass("navbar-main");
        $('.nav-main-icons .navbar-collapse').removeClass('show');
        $('.nav-item.dropdown').removeClass('show');
        $('.nav-item.dropdown').each(function () {
            $(this).children('.dropdown-menu').first().removeClass('show');
        });

        $('.nav-link.dropdown-toggle').each(function () {
            if ($(this).attr("href") && ($(this).attr("href").includes("void") || $(this).attr("href").includes("#"))) {
                $(this).attr("aria-expanded", false);
            }
        });

        if ($(window).width() < 992) {
            if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
                KoreaBreadcrumbSpace();
            }
        }
    }

    function deactivate(className) {
        $('.' + className).removeClass(className);
    }

    function thisOrClosest(element, className) {
        return element.hasClass(className) ? element : element.closest('.' + className);
    }

    $(document).ready(function () {
        $('.chevronMainNav').on('keypress click', function (e) {
            if (e.type === 'click') {
                e.stopPropagation();
            }
            if (e.type === 'click' || e.which === 13) {
                $(this).closest(".dropdown-menu").removeClass("show").removeAttr('data-bs-popper');
                $(this).closest(".dropdown-menu").siblings(".nav-link").removeClass("show").attr('aria-expanded', 'false');
            }
        });
    });

    $(".nav-main-item a").click(function (e) {
        var clickedel = $(e.currentTarget);
        if (clickedel.attr('href') && clickedel.attr('href').includes('#')) {
            setTimeout(function () {
                if (clickedel.parent().hasClass("nav-main-item-active")) {
                    clickedel.attr("aria-expanded", true);
                } else {
                    clickedel.attr("aria-expanded", false);
                }
            }, 50);
        }
    });
    
}(window.jQuery));

(function ($) {
    $('.nav-item.dropdown').click(function () {
        var width = $(document).width();
        if (width >= 991) {
            $('.nav-item.dropdown').removeClass('show');
            $('.nav-item.dropdown').each(function () {
                $(this).children('.dropdown-menu').first().removeClass('show');
            });
            $('.nav-link.dropdown-toggle').each(function () {
                if ($(this).attr("href") && ($(this).attr("href").includes("void") || $(this).attr("href").includes("#"))) {
                    $(this).attr("aria-expanded", true);
                }
            });
            $(this).addClass('show');
            if ($(this).find(".nav-link.dropdown-toggle") && $(this).find(".nav-link.dropdown-toggle").attr("href") && ($(this).find(".nav-link.dropdown-toggle").attr("href").includes("void") || $(this).find(".nav-link.dropdown-toggle").attr("href").includes("#"))) {
                $(this).children('.nav-link.dropdown-toggle').first().attr('aria-expanded', true);
            }
            $(this).children('.dropdown-menu').first().addClass('show');
        }
    });
}(window.jQuery));

(function ($) {
    function setDropdownMenuToggle() {
        var width = $(document).width();
        if (width >= 991) {
            $('.nav-link.dropdown-toggle').each(function () {
                if ($(this).attr("href").charAt(0) == "#") {
                    $(this).attr('data-bs-toggle', '');
                    var attribute = 'javascript' + String.fromCharCode(58) + 'void(0);';
                    $(this).attr('href', attribute);
                }
            });
        }
        else {
            $('.nav-link.dropdown-toggle').each(function () {
                if ($(this).attr("href").includes("void")) {
                    $(this).attr('data-bs-toggle', 'dropdown');
                    $(this).attr('href', '#');
                }
            });
        }
    }

    $(document).ready(function () {
        setDropdownMenuToggle();
    });
    $(window).resize(function () {
        setDropdownMenuToggle();
    });
}(window.jQuery));

(function ($) {
    $("#mainmenu a").click(function () {
        // Cache the clicked menu item
        var $menuItem = $(this);
        var hashVal = $menuItem.attr("href").startsWith("#");

        if (hashVal) {
            $("#mainmenu a").removeClass("nav-parent-source");
            $menuItem.addClass("nav-parent-source");
        } else {
            $("#mainmenu a").removeClass("nav-parent-source");
        }
    });
}(window.jQuery));
